shadow$provide[253] = function(require,module,exports) {
var require$_DOT__SLASH_axis_DOT_js = require("./axis.js");
var require$_DOT__SLASH_face_DOT_js = require("./face.js");
var require$_DOT__SLASH_grid_DOT_js = require("./grid.js");
var require$_DOT__SLASH_line_DOT_js = require("./line.js");
var require$_DOT__SLASH_point_DOT_js = require("./point.js");
var require$_DOT__SLASH_strip_DOT_js = require("./strip.js");
var require$_DOT__SLASH_surface_DOT_js = require("./surface.js");
var require$_DOT__SLASH_ticks_DOT_js = require("./ticks.js");
var require$_DOT__SLASH_vector_DOT_js = require("./vector.js");
require.exportCopy(module, require$_DOT__SLASH_axis_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_face_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_grid_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_line_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_point_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_strip_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_surface_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_ticks_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_vector_DOT_js);

};